var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"text-left text-font-24"},[_vm._v("ข้อมูลองค์กร")]),_c('ProfileCompanyForm',{attrs:{"value":_vm.value},on:{"setFormStep":_vm.nextStep}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }